import React, { useEffect } from "react";
import { Grid, Typography, useMediaQuery, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import formatMoney from "../../../utils/formatMoney";
import { useTheme } from "@mui/styles";
import { useFormikContext } from "formik";
import { getLessonById } from "../../../actions/typeOfLesson";
import { connect } from "react-redux";
import { milliseconds } from "date-fns";
import Spinner from "../../ui/Spinner";
import styled from "@emotion/styled";

const PricingButton = styled(Button)({
  width: "10em",
  borderRadius: "50%",
  height: "5em",
  color: 'white'
});

const ChooseDuration = ({
  getLessonById,
  typeOfLesson: { lesson, loading },
  nextPage,
}) => {
  const { setFieldValue, values } = useFormikContext();

  const handleClickThirtyMinutes = (price) => {
    setFieldValue("duration", milliseconds({ minutes: 30 }));
    setFieldValue("price", price);
    nextPage();
  };

  const handleClickFortyFiveMinutes = (price) => {
    setFieldValue("duration", milliseconds({ minutes: 45 }));
    setFieldValue("price", price);
    nextPage();
  };

  const handleClickOneHour = (price) => {
    setFieldValue("duration", milliseconds({ minutes: 60 }));
    setFieldValue("price", price);
    nextPage();
  };

  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.up("sm"));
  const matchesMD = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    getLessonById(values.lesson);
  }, [getLessonById, values.lesson]);

  return (
    <Grid item container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Typography
          variant={matchesMD ? "h4" : "h5"}
          style={{
            textTransform: "uppercase",
            textAlign: "center",
            fontWeight: "600",
          }}
        >
          Chọn thời lượng của bài học
        </Typography>
      </Grid>
      <Grid
        item
        container
        direction={matchesSM ? "row" : "column"}
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Grid item>
              <Grid container direction="column" alignItems="center">
                {lesson &&
                  lesson.periods[0] &&
                  lesson.periods[0].thirtyMinutes.price !== 0 &&
                  lesson.periods[0].thirtyMinutes.isChosen && (
                    <>
                      <Grid item>
                        <Typography variant="h6">30 phút</Typography>
                      </Grid>
                      <Grid item style={{ marginBottom: "1.5em" }}>
                        <ExpandMoreIcon fontSize="large" />
                      </Grid>
                      <Grid item>
                        <PricingButton
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleClickThirtyMinutes(
                              lesson.periods[0].thirtyMinutes.price
                            )
                          }
                        >
                          {formatMoney(lesson.periods[0].thirtyMinutes.price)}
                          &nbsp;VNĐ
                        </PricingButton>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Grid>

            <Grid item>
              <Grid container direction="column" alignItems="center">
                {lesson &&
                  lesson.periods[0] &&
                  lesson.periods[0].fortyFiveMinutes.price !== 0 &&
                  lesson.periods[0].fortyFiveMinutes.isChosen && (
                    <>
                      <Grid item>
                        <Typography variant="h6">45 phút</Typography>
                      </Grid>
                      <Grid item style={{ marginBottom: "1.5em" }}>
                        <ExpandMoreIcon fontSize="large" />
                      </Grid>
                      <Grid item>
                        <PricingButton
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleClickFortyFiveMinutes(
                              lesson.periods[0].fortyFiveMinutes.price
                            )
                          }
                        >
                          {formatMoney(
                            lesson.periods[0].fortyFiveMinutes.price
                          )}
                          &nbsp;VNĐ
                        </PricingButton>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Grid>

            <Grid item>
              <Grid container direction="column" alignItems="center">
                {lesson &&
                  lesson.periods[0] &&
                  lesson.periods[0].oneHour.price !== 0 &&
                  lesson.periods[0].oneHour.isChosen && (
                    <>
                      <Grid item>
                        <Typography variant="h6">60 phút</Typography>
                      </Grid>
                      <Grid item style={{ marginBottom: "1.5em" }}>
                        <ExpandMoreIcon fontSize="large" />
                      </Grid>
                      <Grid item>
                        <PricingButton
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleClickOneHour(lesson.periods[0].oneHour.price)
                          }
                        >
                          {formatMoney(lesson.periods[0].oneHour.price)}
                          &nbsp;VNĐ
                        </PricingButton>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  typeOfLesson: state.typeOfLesson,
});

export default connect(mapStateToProps, { getLessonById })(ChooseDuration);
